import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export interface LoclIconProps {
  size?: SizeProp;
}

const LockIcon: React.FC<LoclIconProps> = ({ size = null }) => {
  return <FontAwesomeIcon icon={faLock} size={size} className="text-voxel-gray-500" />;
};

export default LockIcon;
